// We don't support setting automating the nonce attribute in the npm package
"use strict";